export default __webpack_public_path__ + "static/media/pos-report.7a23126e.webp";